export default "__VITE_ASSET__peXUdqh0__"